/* ==========================================================================
   SKOCKZ tilt cards — assets/skx-tilt.js
   Product and review cards lean toward the cursor in 3D.

   Loaded by snippets/skx-motion.liquid, which also carries the two transition
   classes this file toggles.

   Mouse only. On a touch screen there is no cursor to lean toward, and
   :hover sticks after a tap, so the whole thing is skipped there.
   ========================================================================== */

(function () {
  'use strict';

  if (!window.matchMedia) return;
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var html = document.documentElement;
  var SEL = '.skx-card,.skc-card,.skxr__card,.skr__card';

  var MAX = parseFloat(html.getAttribute('data-skx-tilt')) || 8;   /* degrees */

  /* The cards already lift 6px on :hover in their own stylesheets. Once this
     file writes an inline transform that rule is out-voted, so the lift has to
     be folded back into the matrix or the card would drop while tilting. */
  var LIFT = -6;

  var active = null, px = 0, py = 0, queued = false;

  function apply() {
    queued = false;
    if (!active) return;

    /* Re-measured per frame rather than cached on enter: the page can scroll
       under a stationary cursor, and a stale rect makes the card lean the
       wrong way. */
    var r = active.getBoundingClientRect();
    if (!r.width || !r.height) return;

    var dx = (px - (r.left + r.width / 2)) / (r.width / 2);
    var dy = (py - (r.top + r.height / 2)) / (r.height / 2);
    dx = dx < -1 ? -1 : dx > 1 ? 1 : dx;
    dy = dy < -1 ? -1 : dy > 1 ? 1 : dy;

    active.style.transform =
      'perspective(760px) rotateX(' + (-dy * MAX).toFixed(2) + 'deg)' +
      ' rotateY(' + (dx * MAX).toFixed(2) + 'deg)' +
      ' translateY(' + LIFT + 'px)';
  }

  function release(el) {
    if (!el) return;
    el.classList.remove('skx-tilt-on');
    el.classList.add('skx-tilt-off');
    el.style.transform = '';
    setTimeout(function () { el.classList.remove('skx-tilt-off'); }, 450);
  }

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;

    var card = e.target && e.target.closest ? e.target.closest(SEL) : null;

    /* A card still playing its scroll-reveal is left alone — the animation
       out-ranks inline styles anyway, so tilting it would do nothing visible
       now and then snap into place the moment the reveal finished. */
    if (card && card.classList.contains('skx-rv-in') &&
        getComputedStyle(card).animationName !== 'none') card = null;

    if (card !== active) {
      release(active);
      active = card;
      if (active) {
        active.classList.remove('skx-tilt-off');
        active.classList.add('skx-tilt-on');
      }
    }
    if (!active) return;

    px = e.clientX;
    py = e.clientY;
    if (!queued) { queued = true; requestAnimationFrame(apply); }
  }, { passive: true });

  /* Cursor leaving the window fires no pointermove over a non-card, so the
     last hovered card would stay tilted. */
  document.addEventListener('pointerleave', function () {
    release(active);
    active = null;
  });
  window.addEventListener('blur', function () {
    release(active);
    active = null;
  });
})();
